import { Snackbar, Alert as MuiAlert } from '@mui/material';
import { closeAlert, useAppDispatch, useAppSelector } from 'api';

export const Alert = () => {
  // Hooks
  const { openAlert, alertContent } = useAppSelector(state => state.alert);
  const dispatch = useAppDispatch();

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(closeAlert());
  };

  return (
    <Snackbar
      open={openAlert}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ top: '10px !important' }}
    >
      <MuiAlert onClose={handleClose} severity={alertContent.severity}>
        {alertContent.message}
      </MuiAlert>
    </Snackbar>
  );
};
